<template>
  <div class="news">
    <div class="page-heading">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>新闻资讯</h1>
            <span>关注行业发展，聚焦门窗工艺，梵蒂斯持续更新中</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻列表 -->
    <div class="blog-entries-01 blog-entries-02 section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="blog-posts">
              <div class="row">
                <div v-for="(item,index) in newsList" :key="index" class="col-lg-4">
                  <div class="blog-post">
                    <el-image
                      style="width: 100%;height: 200px;max-height: 200px"
                      :src="item.headimg"
                      fit="cover"></el-image>
<!--                    <img :src="item.headimg" alt="">-->
                    <div class="down-content">
                      <span><a href="#">{{ item.newstime }}</a></span>
                      <h4 class="newsTitle">{{ item.title }}</h4>
<!--                      <p class="newsDescT" v-html="item.context"></p>-->
                      <div  class="text-button" @click.prevent="toNewsInfo(item.id)">
                        <a href="#">查看新闻</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :hide-on-single-page="true"
                  :current-page="pager.page"
                  :total="pager.total"
                  @current-change="handleCurrentChange">
                </el-pagination>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'news',
  data() {
    return {
      pager:{
        size:9,
        page:1,
        total:100
      },
      newsList:[]
    }
  },
  created() {
    this.getData();
  },
  methods:{
    // 查询新闻数据
    getData(){
      let _this = this;
      this.$axios.get('/fantis/news/ftCmsNews/list?pageNo='+_this.pager.page+'&pageSize='+_this.pager.size)
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result.records;
            _this.pager.total = res.data.result.total;
            for(var i in tempData){
              if(tempData[i].headimg.startsWith('//') || tempData[i].headimg.startsWith('https://') || tempData[i].headimg.startsWith('http://')){

              }else{
                tempData[i].headimg = _this.$fileDPath + tempData[i].headimg;
              }
            }

            _this.newsList = tempData;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 翻页时
    handleCurrentChange(val){
      this.pager.page = val;
      this.getData();
    },
    // 点击跳转到新闻详情页
    toNewsInfo(newsID){
      this.$router.push({
        name:"newsInfo",
        query:{"newsID":newsID}
      });
    }
  }
}
</script>

<style scoped>
.newsDescT{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.newsTitle{
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/views/news/news.vue